<template>
<router-view />
</template>

<script>
export default {
	name: "SettingsContainer"
}
</script>

<style scoped>

</style>